import { Button } from 'react-bootstrap';
import ExcelJS from 'exceljs';

const FormularioExcel = ({ data }) => {
  const handleExcelDownload = async () => {
    // Safely access data or provide fallback empty arrays
    const principalData = data?.principalData || [];
    const infractorData = data?.infractorData || [];
    const testigoData = data?.testigoData || [];
    const afectadoData = data?.afectadoData || [];

    const workbook = new ExcelJS.Workbook();

    // Hoja 1: Datos principales
    const principalSheet = workbook.addWorksheet('Datos principales');
    principalSheet.columns = [
      { header: ' ', key: 'col1', width: 40 },
      { header: ' ', key: 'col2', width: 60 }
    ];

    // Agregar datos principales con verificación de contenido
    if (principalData.length > 0) {
      principalSheet.addRows(principalData);
    } else {
      principalSheet.addRow(['No hay datos principales', '']);
    }

    // Hoja 2: Infractores
    const infractoresSheet = workbook.addWorksheet('Infractores');
    infractoresSheet.columns = [
      { header: 'Nombre completo', key: 'invNombre', width: 30 },
      { header: 'Puesto', key: 'invPuestoRelacion', width: 30 }
    ];
    if (infractorData.length > 0) {
      infractoresSheet.addRows(infractorData);
    } else {
      infractoresSheet.addRow(['No hay infractores', '']);
    }

    // Hoja 3: Testigos
    const testigosSheet = workbook.addWorksheet('Testigos');
    testigosSheet.columns = [
      { header: 'Nombre completo', key: 'invNombre', width: 30 },
      { header: 'Puesto', key: 'invPuestoRelacion', width: 30 },
      { header: 'Ubicación', key: 'invUbicacion', width: 30 },
      { header: 'Teléfono móvil', key: 'invTelMovil', width: 20 }
    ];
    if (testigoData.length > 0) {
      testigosSheet.addRows(testigoData);
    } else {
      testigosSheet.addRow(['No hay testigos', '', '', '']);
    }

    // Hoja 4: Afectados
    const afectadosSheet = workbook.addWorksheet('Afectados');
    afectadosSheet.columns = [
      { header: 'Nombre completo', key: 'invNombre', width: 30 },
      { header: 'Puesto', key: 'invPuestoRelacion', width: 30 },
      { header: 'Ubicación', key: 'invUbicacion', width: 30 },
      { header: 'Teléfono móvil', key: 'invTelMovil', width: 20 }
    ];
    if (afectadoData.length > 0) {
      afectadosSheet.addRows(afectadoData);
    } else {
      afectadosSheet.addRow(['No hay afectados', '', '', '']);
    }

    // Aplicar estilos a todas las hojas
    [principalSheet, infractoresSheet, testigosSheet, afectadosSheet].forEach(sheet => {
      sheet.eachRow((row, rowNumber) => {
        row.height = Math.max(25, Math.floor(row.height * 1.2));
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };

          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: true
          };

          cell.font = { size: 11 };

          if (sheet === principalSheet && cell.col === 1) {
            cell.font = { size: 11, bold: true };
          }
        });
      });

      if (sheet !== principalSheet) {
        const headerRow = sheet.getRow(1);
        headerRow.font = {
          bold: true,
          size: 12
        };
        headerRow.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE0E0E0' }
        };
      }
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      // Tomar el folio del primer registro de principalData o usar un nombre por defecto
      const folio = principalData[0]?.col2 || 'reporte';
      anchor.download = `TEscucha_folio_${folio}.xlsx`;
      anchor.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al generar el Excel:', error);
    }
  };

  return (
    <Button
      variant="outline-success"
      onClick={handleExcelDownload}
    >
      xls
    </Button>
  );
};

export default FormularioExcel;
